/* eslint-disable */

import { Box, Grid, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { useResponsiveStyles } from '../../../utils/responsiveStyles';
import moment from 'moment';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(name, description, quantity) {
  return { name, description, quantity };
}

const InvioceDetails = ({ invoiceDetails }) => {
  const styles = useResponsiveStyles();
  const [formData, setFormData] = useState({
    number: '',
    companyName: '',
    email: '',
    status: '',
    dueDate: '',
    trailDays: '',
    amount: '',
    items: [],
    salesName: '',
    salesPhone: '',
    salesEmail: '',
  });
  const [rows, setRows] = useState([]);
  console.log('invoiceDetails', invoiceDetails);

  useEffect(() => {
    const rowData = invoiceDetails?.items.map((data) => createData(data?.name, data?.description, data?.quantity));
    setRows(rowData);
    setFormData((prev) => ({
      ...prev,
      number: invoiceDetails?.invoice_number,
      companyName: invoiceDetails?.company_name,
      email: invoiceDetails?.email,
      dueDate: invoiceDetails?.due_date,
      trailDays: invoiceDetails?.trail_period == 1 ? invoiceDetails?.trail_days.toString() || '0' : '0',
      amount: invoiceDetails?.price,
      status: invoiceDetails?.paid === 1 ? 'Paid' : invoiceDetails?.paid === 2 ? 'Expired' : 'Not Paid',
      salesEmail: invoiceDetails?.admin_email,
      salesPhone: invoiceDetails?.admin_mobile,
      salesName: invoiceDetails?.admin_name,
    }));
  }, [invoiceDetails]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const textStyles = {
    fontSize: styles.fontSize12,
    fontWeight: 600,
  };
  return (
    <>
      <Grid
        container
        spacing={1}
        sx={{
          '.css-r0m7rw-MuiInputBase-root-MuiOutlinedInput-root': {
            height: '34.5px',
          },
          '& .MuiInputBase-input': {
            fontSize: '12px',
          },
          p: '10px',
          border: '1px solid #eee'
        }}
      >
        <Grid item container spacing={1} xs={6}>
        <Grid item xs={12} sx={{textAlign:'center'}}>
            <Typography variant="body2" sx={{ ...textStyles }}>
                Invoice Details
                </Typography>
            </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Inovice No.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Invoice"
                size="small"
                // type="number"
                value={formData.number}
                onChange={(e) => handleChange('number', e.target.value)}
                id="number"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Customer
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Company Name"
                size="small"
                value={formData.companyName}
                onChange={(e) => handleChange('companyName', e.target.value)}
                id="companyName"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Email
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Email"
                size="small"
                value={formData.email}
                onChange={(e) => handleChange('email', e.target.value)}
                id="email"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Status
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Status"
                size="small"
                value={formData.status}
                onChange={(e) => handleChange('status', e.target.value)}
                id="status"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Due Date
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Status"
                size="small"
                value={moment(formData.dueDate).format('LL')}
                onChange={(e) => handleChange('dueDate', e.target.value)}
                id="dueDate"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                  Amount
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="amount"
                size="small"
                value={formData.amount}
                onChange={(e) => handleChange('amount', e.target.value)}
                id="amount"
                autoComplete="off"
                InputProps={{
                  endAdornment: <InputAdornment position="end">$</InputAdornment>,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        </Grid>

        <Grid item container spacing={1} xs={6}>
            <Grid item xs={12} sx={{textAlign:'center'}}>
            <Typography variant="body2" sx={{ ...textStyles, }}>
                Sales Team Details
                </Typography>
            </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                Name
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Sales Contact Name"
                size="small"
                value={formData.salesName}
                onChange={(e) => handleChange('salesName', e.target.value)}
                id="salesName"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                 Phone
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Sales Contact Number"
                size="small"
                value={formData.salesPhone}
                onChange={(e) => handleChange('salesPhone', e.target.value)}
                id="salesPhone"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Grid item container xs={12} sx={{ alignItems: 'center' }}>
            <Grid item xs={4}>
              <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', pr: '5px' }}>
                <Typography variant="body2" sx={{ ...textStyles }}>
                Email
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                disabled
                placeholder="Contact Email"
                size="small"
                value={formData.salesEmail}
                onChange={(e) => handleChange('salesEmail', e.target.value)}
                id="salesEmail"
                autoComplete="off"
              />
            </Grid>
          </Grid>
        </Grid>


        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'start',
              width: '100%',
              height: window.innerHeight - 100,
              // bgcolor: '#F2F4FA',
              p: '10px',
            }}
          >
            <TableContainer component={Paper} elevation={4}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="left">Item Name </StyledTableCell>
                    <StyledTableCell align="left">Item Description </StyledTableCell>
                    <StyledTableCell align="left">Quantity</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {rows &&
                    rows?.map((row) => (
                      <StyledTableRow key={row.itemid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.description}</StyledTableCell>
                        <StyledTableCell align="left">{row.quantity}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default InvioceDetails;
